/* global propel */

import { Loader } from '@googlemaps/js-api-loader';

if (propel.googleApiKey) {
	const loader = new Loader({
		apiKey: propel.googleApiKey,
		version: 'weekly',
	});

	loader.importLibrary('maps').then(() => {
		const loadedEvent = new Event('google-maps-loaded');
		window.dispatchEvent(loadedEvent);
	});
}
